import { useCountries } from 'api/requests/country';
import {
  AutocompleteField,
  AutocompleteFieldProps,
} from 'libs/form/fields/AutocompleteField';

interface CountryAutocompleteFieldProps<
  Value extends object,
  Multiple extends boolean | undefined
> extends Omit<
    AutocompleteFieldProps<Value, Multiple>,
    'options' | 'optionValueKey' | 'optionLabelKey'
  > {}

export const CountryAutocompleteField = <
  Value extends object,
  Multiple extends boolean | undefined
>({
  ...autocompleteFieldProps
}: CountryAutocompleteFieldProps<Value, Multiple>) => {
  const { countries, loading } = useCountries();
  return (
    <AutocompleteField
      {...autocompleteFieldProps}
      loading={loading}
      optionLabelKey="label"
      options={
        (countries ?? []).map((country) => ({
          label: country.name,
          value: country.id,
        })) as Value[]
      }
      optionValueKey="value"
    />
  );
};
